<template>
    <div class="container downloadoneapp hmi">
        <div class="title tm-top">Download the Toyota App</div>
        <div class="subtext">You may register your vehicle and add services from within the Toyota app.  Enter your phone number below to receive a download link.</div>
        <div class="my-3"></div>
        <div class="row">
            <div class="col">
                <router-link to="/enterphonenumber">
                    <button>Enter phone number</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DownloadOneApp"
    }
</script>

<style scoped>
    .hmi{
        height:540px;
        /*background-image: linear-gradient(90deg, #733AEA 0%, #217CF6 100%);*/
        background-color: #F8F8FA;
        border: 1px solid #979797;
        color:white;
    }
    .tm-top{
        margin-top:107px;
    }
    .title{
        font-family: ToyotaType-Semibold;
        font-size: 40px;
        color: #1D1F20;
        letter-spacing: -0.5px;
        text-align: center;
    }
    .subtext{
        color: rgb(147, 147, 162);
        font-family: ToyotaType-Regular;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: -0.5px;
        text-align: center;
    }
    button{
        background: linear-gradient(-135deg, rgb(66, 129, 255) 0%, rgb(117, 117, 255) 100%);
        border-radius: 37px;
        height: 74px;
        width: 269px;
        color: rgb(255, 255, 255);
        font-family: ToyotaType-Semibold;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: -0.5px;
        text-align: center;
    }
    a:link {
        color:#FFFFFF;
    }
</style>
